import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getOpsApiBaseUrl } from '../api/client.ts';
import { buttonClass } from '../ui/index.ts';

interface FeishuLoginLandingProps {
  navigate?: (url: string) => void;
}

const defaultNavigate = (url: string): void => {
  window.location.assign(url);
};

export function FeishuLoginLanding({
  navigate = defaultNavigate,
}: FeishuLoginLandingProps): JSX.Element {
  const location = useLocation();
  const startUrl = useMemo(() => buildFeishuStartUrl(location.search), [location.search]);

  useEffect(() => {
    navigate(startUrl);
  }, [navigate, startUrl]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas px-6 text-paper">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="h-2 w-24 rounded-full bg-signal" aria-hidden="true" />
        <h1 className="m-0 text-title text-paper">Opening Feishu sign-in</h1>
        <a
          href={startUrl}
          data-testid="feishu-login-landing-link"
          className={buttonClass('secondary')}
        >
          Continue
        </a>
      </div>
    </main>
  );
}

export function buildFeishuStartUrl(search: string): string {
  const params = new URLSearchParams(search);
  const returnTo = sanitizeReturnTo(params.get('return_to'));
  const start = new URL('/v1/auth/feishu/start', `${getOpsApiBaseUrl()}/`);
  start.searchParams.set('return_to', returnTo);
  return start.toString();
}

function sanitizeReturnTo(raw: string | null): string {
  if (raw === null || raw.length === 0) {
    return '/';
  }
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return '/';
  }
  return raw;
}
